// @generated by rtk-query-codegen -- DO NOT EDIT
import { baseApi as api } from "../client/baseApi";
import type { DataShareResponse } from "../dataShare/dto.generated";
export const addTagTypes = ["data-shares"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getApiDataSharesByDataShareId: build.query<
        GetApiDataSharesByDataShareIdApiResponse,
        GetApiDataSharesByDataShareIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/data-shares/${encodeURIComponent(String(queryArg.dataShareId))}`,
        }),
        providesTags: ["data-shares"],
      }),
      getApiProjectsByProjectIdDataShares: build.query<
        GetApiProjectsByProjectIdDataSharesApiResponse,
        GetApiProjectsByProjectIdDataSharesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/data-shares`,
        }),
        providesTags: ["data-shares"],
      }),
      postApiProjectsByProjectIdDataShares: build.mutation<
        PostApiProjectsByProjectIdDataSharesApiResponse,
        PostApiProjectsByProjectIdDataSharesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/data-shares`,
          method: "POST",
          body: queryArg.dataSharesDataShareRequest,
        }),
        invalidatesTags: ["data-shares"],
      }),
      deleteApiProjectsByProjectIdDataSharesAndDataShareId: build.mutation<
        DeleteApiProjectsByProjectIdDataSharesAndDataShareIdApiResponse,
        DeleteApiProjectsByProjectIdDataSharesAndDataShareIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/data-shares/${encodeURIComponent(String(queryArg.dataShareId))}`,
          method: "DELETE",
        }),
        invalidatesTags: ["data-shares"],
      }),
      patchApiProjectsByProjectIdDataSharesAndDataShareId: build.mutation<
        PatchApiProjectsByProjectIdDataSharesAndDataShareIdApiResponse,
        PatchApiProjectsByProjectIdDataSharesAndDataShareIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/data-shares/${encodeURIComponent(String(queryArg.dataShareId))}`,
          method: "PATCH",
          body: queryArg.dataSharesUpdateDataShareRequest,
        }),
        invalidatesTags: ["data-shares"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as dataShareApi };
export type GetApiDataSharesByDataShareIdApiResponse =
  /** status 200 OK */ { data: DataSharesDataShareResponse };
export type GetApiDataSharesByDataShareIdApiArg = {
  /** Data Share ID */
  dataShareId: string;
};
export type GetApiProjectsByProjectIdDataSharesApiResponse =
  /** status 200 OK */ { data: DataSharesDataShareResponse[] };
export type GetApiProjectsByProjectIdDataSharesApiArg = {
  /** Project ID */
  projectId: string;
};
export type PostApiProjectsByProjectIdDataSharesApiResponse =
  /** status 201 Created */ { data: DataSharesDataShareResponse };
export type PostApiProjectsByProjectIdDataSharesApiArg = {
  /** Project ID */
  projectId: string;
  /** Data share creation request */
  dataSharesDataShareRequest: DataSharesDataShareRequest;
};
export type DeleteApiProjectsByProjectIdDataSharesAndDataShareIdApiResponse =
  /** status 200 OK */ { data: string };
export type DeleteApiProjectsByProjectIdDataSharesAndDataShareIdApiArg = {
  /** Project ID */
  projectId: string;
  /** Data Share ID */
  dataShareId: string;
};
export type PatchApiProjectsByProjectIdDataSharesAndDataShareIdApiResponse =
  /** status 200 OK */ { data: DataSharesDataShareResponse };
export type PatchApiProjectsByProjectIdDataSharesAndDataShareIdApiArg = {
  /** Project ID */
  projectId: string;
  /** Data Share ID */
  dataShareId: string;
  /** Update request */
  dataSharesUpdateDataShareRequest: DataSharesUpdateDataShareRequest;
};
export type DataSharesDataShareResponse = DataShareResponse;
export type DataSharesDataShareRequest = {
  consumer_project_id?: string;
  expires_at?: string;
  table_names?: string[];
};
export type DataSharesUpdateDataShareRequest = {
  expires_at?: string;
  table_names?: string[];
};
export const {
  useGetApiDataSharesByDataShareIdQuery,
  useLazyGetApiDataSharesByDataShareIdQuery,
  useGetApiProjectsByProjectIdDataSharesQuery,
  useLazyGetApiProjectsByProjectIdDataSharesQuery,
  usePostApiProjectsByProjectIdDataSharesMutation,
  useDeleteApiProjectsByProjectIdDataSharesAndDataShareIdMutation,
  usePatchApiProjectsByProjectIdDataSharesAndDataShareIdMutation,
} = injectedRtkApi;
